//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faShieldHalved } from '@fortawesome/pro-solid-svg-icons';

import {
  faCcVisa,
  faCcMastercard,
  faCcAmex,
} from '@fortawesome/free-brands-svg-icons';

import { faMeJcb } from '@/assets/icons/me-font-icons-regular';

export default {
  name: 'SubscribePaymentMethods',
  data() {
    return {
      faCcVisa,
      faCcMastercard,
      faCcAmex,
      faMeJcb,
      faShieldHalved,
    };
  },
};
